import React from 'react';
import { bool, func, string } from 'prop-types';
import styled, { css } from 'styled-components';
import {
  Button, Flex, Typography, Icon, Modal,
} from '@atoms';
import { ReactComponent as Close } from '@assets/remove-item.svg';

const DeleteModal = ({
  name,
  onDelete,
  onModalClose,
  isModalOpen,
}) => (
  <Modal
    isOpen={isModalOpen}
    ariaHideApp={false}
    onRequestClose={onModalClose}
    shouldCloseOnOverlayClick
  >
    <ButtonClose primary onClick={onModalClose}>
      <Flex justifyCenter itemsCenter>
        <Icon SVG={Close} width="20px" height="20px" />
      </Flex>
    </ButtonClose>
    <Typography size="xl" weight="black">
      Would you like to delete
      {' '}
      <Typography as="span" size="xl" weight="black" color="strawberry">
        {name}
      </Typography>
      ?
    </Typography>
    <Button.Rectangular
      fullWidth
      primary
      padding="xl"
      onClick={onDelete}
      marginTop="xl5"
    >
      <Typography size="lg">
        Confirm
      </Typography>
    </Button.Rectangular>
    <Button.Rectangular
      fullWidth
      primaryInverted
      padding="xl"
      onClick={onModalClose}
      marginTop="md"
    >
      <Typography size="lg">
        Cancel
      </Typography>
    </Button.Rectangular>
  </Modal>
);

const ButtonClose = styled(Button.Circular)`
  ${({ theme: { spacing } }) => css`
    padding: ${spacing.xs};
    position: absolute;
    top: 10px;
    right: 10px;
  `}
`;

DeleteModal.propTypes = {
  name: string.isRequired,
  onDelete: func.isRequired,
  onModalClose: func.isRequired,
  isModalOpen: bool.isRequired,
};

export default DeleteModal;
